module.exports = ".signpost-trigger {\n  margin-left: 0.15rem;\n  margin-right: 0.15rem; }\n"